export default "/images/22fd28dc9ce9623c958a42db936a6b16.avif";